const appName = {
  chn: "Pearl",
  en: { uppercase: "Pearl", lowercase: "pearl" },
};

export default {
  BBS_title: {
    chn: appName.chn + "商戶平台",
    en: appName.chn + " Business Platform",
  },
  Logout: { chn: "登出", en: "Logout" },
  V_Code: { chn: "驗證碼", en: "Verification Code" },
  Back: { chn: "返回", en: "Back" },
  Confirm: { chn: "確定", en: "Confirm" },
  next: { chn: "下一步", en: "Next" },
  previous: { chn: "上一步", en: "Previous" },
  homepage: { chn: "主頁", en: "Home Page" },
  ComingSoon: { chn: "即將推出", en: "Coming Soon" },
  language: { chn: "語言", en: "Language" },
  name: { chn: "名稱", en: { uppercase: "Name", lowercase: "name" } },
  nickname: { chn: "暱稱", en: "Nickname" },
  phone: { chn: "電話", en: "Phone" },
  email: { chn: "電郵", en: "E-mail" },
  vendor: { chn: "商戶", en: { uppercase: "Shop", lowercase: "shop" } },
  hidden: { chn: "已隱藏", en: "hidden" },
  approved: { chn: "批准", en: "Approved" },
  intro: { chn: "簡介", en: "Introduction" },
  download: {
    chn: "下載",
    en: { uppercase: "Download", lowercase: "download" },
  },
  processing: {
    chn: "處理中",
    en: { uppercase: "Processing", lowercase: "processing" },
  },
  mustwrite: { chn: "為必填", en: "Required" },
  cancel: { chn: "取消", en: "Cancel" },
  add: { chn: "增加", en: "Add" },
  setting: { chn: "設定", en: { uppercase: "Setting", lowercase: "setting" } },
  choose: { chn: "選擇", en: "Choose" },
  location: { chn: "筍點", en: "location" },
  category: { chn: "分類", en: "Category" },
  complete: { chn: "完成", en: "Complete" },
  success: { chn: "成功", en: "success" },
  error: { chn: "錯誤", en: "Error" },
  status: { chn: "狀態", en: "Status" },
  description: { chn: "說明", en: "Description" },
  NA: { chn: "暫無", en: "No Data" },
  retry: { chn: "請重試", en: "Please re-try" },
  voucher: {
    chn: "電子劵",
    en: { uppercase: "Voucher", lowercase: "voucher" },
  },
  discount: {
    chn: "優惠劵",
    en: { uppercase: "Discount", lowercase: "discount" },
  },
  assistant: { chn: "員工", en: { uppercase: "Staff", lowercase: "staff" } },
  general_assistant: {
    chn: "一般員工",
    en: { uppercase: "General Staff", lowercase: "general staff" },
  },
  takeaway_assistant: {
    chn: "外賣員工",
    en: { uppercase: "Takeaway Staff", lowercase: "takeaway staff" },
  },
  consumer: {
    chn: "消費者",
    en: { uppercase: "Consumer", lowercase: "consumer" },
  },
  takeaway: {
    chn: "外賣",
    en: { uppercase: "Takeaway", lowercase: "takeaway" },
  },
  appName,
  weekday: {
    mon: { chn: "星期一", en: { uppercase: "Mon", lowercase: "mon" } },
    tue: { chn: "星期二", en: { uppercase: "Tue", lowercase: "tue" } },
    wed: { chn: "星期三", en: { uppercase: "Wed", lowercase: "wed" } },
    thu: { chn: "星期四", en: { uppercase: "Thu", lowercase: "thu" } },
    fri: { chn: "星期五", en: { uppercase: "Fri", lowercase: "fri" } },
    sat: { chn: "星期六", en: { uppercase: "Sat", lowercase: "sat" } },
    sun: { chn: "星期日", en: { uppercase: "Sun", lowercase: "sun" } },
  },
  estamp: { chn: "積分", en: "Estamp" },
  EstampPlan: { chn: "積分計劃", en: "Estamp Plan" },
  event: { chn: "推廣活動", en: "Event" },
  rewardEvent: { chn: "禮遇計劃", en: { uppercase: "Reward Event", lowercase: "reward event"} },
  Pending: { chn: "尚未推行", en: "Pending" },
  OnGoing: { chn: "進行中", en: "On Going" },
  Expired: { chn: "已結束", en: "Expired" },
  Cancelled: { chn: "已取消", en: "Cancelled" },
  ModifyPartnersList: {
    chn: "如要更改此列表, 請聯絡我們",
    en: "If the list needs modification, please contact us at",
  },
  Approved: { chn: "已審批", en: "Approved" },
  WaitApprove: { chn: "審核中", en: "Waiting for approval" },
  Rejected: { chn: "已拒絕", en: "Rejected" },
};
